import { serializable, alias, object, list, primitive } from "serializr";

export class Institutes {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("no_of_branches", primitive()))
  noOfBranches?: number;

  @serializable(alias("is_active", primitive()))
  isActive?: boolean;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("display_logo_url", primitive()))
  logoUrl?: string;

  @serializable(alias("contact_person", primitive()))
  contactPerson?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("registered_address", primitive()))
  registeredAddress?: string;
}

export class Institute {
  @serializable(alias("is_active", primitive()))
  isActive?: boolean;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("contact_person", primitive()))
  contactPerson?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("registered_address", primitive()))
  registeredAddress?: string;

  @serializable(alias("email", primitive()))
  email?: string;
}
